import { FC } from 'react';

import styles from './TournamentRulesModal.module.scss';

type Props = {
  category: string;
  items: string[];
};

const Row: FC<Props> = (props: Props): JSX.Element => {
  const { category, items } = props;

  return (
    <div className={styles.row}>
      <span className={styles.category}>{category}</span>
      <ul>
        {items.map((item) => (
          <li key={`${category}-${item}`} className={styles.item}>
            <div className={styles.bullet} />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Row;
